/* global Webcam: true */

(() => {
  angular
    .module('gm.common.controllers')
    .controller('WebcamModalController', WebcamModalController);

  function WebcamModalController(
    $scope,
    $rootScope,
    GmyUtils
  ) {
    'ngInject';

    function initWebcam() {
      Webcam.setSWFLocation('/flash/webcam.swf');

      Webcam.set({
        width: 640,
        height: 480,
        dest_width: 1280,
        dest_height: 960,
        image_format: 'jpeg',
        jpeg_quality: 90,
        force_flash: false,
        constraints: true
      });

      Webcam.on('error', (error) => {
        $scope.webcamError = error;
      });

      Webcam.attach('#webcam-attach');
    }

    $scope.webcamData = {
      error: null
    };

    initWebcam();

    $scope.onModalClose = () => {
      if (Webcam.live) {
        Webcam.reset();
      }
    };

    $scope.takePicture = () => {
      Webcam.snap((dataUri) => {
        $rootScope.$broadcast('modal:webcamPhoto:picture', GmyUtils.uriToBlob(dataUri));
        $scope.isOpen = false;
        Webcam.reset();
      });
    };
  }
})();
